import axios from './axios';

const API_URL = '/C4-Nicaragua/Productos'; // ajusta si usas otro endpoint"el nombre del archivo de route de backend 

export const getProductos = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener Producto / Servicio :', error);
    return [];
  }
};

export const addProducto = async (productoServicio) => {
  try {
    const response = await axios.post(API_URL, productoServicio);
    return response.data;
  } catch (error) {
    console.error('Error al guardar Producto / Servicio', error);
    throw error;
  }
};

export const updateProducto = async (id, productoServicio) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, productoServicio);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar Producto / Servicio', error);
    throw error;
  }
};

export const eliminarProducto  = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar Producto / Servicio', error);
    throw error;
  }
};
export const  getNumeroNextProducto= async()  =>
{
    try{
      console.log(`${API_URL}/NextNoProducto`)
    const response = await axios.get(`${API_URL}/NextNoProducto`);
    console.log(response);
    return response.data;    
    }
    catch(error)
    {
      console.error('Error al obtener el numero del siguiente producto', error);
      throw error;
    }
}
